<template>
  <div class="navbar-item">
    <div class="is-pulled-right" v-if="hasToken">
      <span class="icon"><i class="fas fa-lg fa-user"></i></span>&nbsp;
      <span>{{ dispname }}さん</span>
      <a class="login-link" v-on:click="logout">ログアウト</a>
      <span class="icon"><i class="fas fa-lg fa-sign-out-alt"></i></span>
      <span class="icon has-text-danger" v-if="isSaigai"><i class="fas fa-lg fa-exclamation-triangle"></i></span>
    </div>
    <div class="is-pulled-right" v-else>
      <router-link class="login-link" to="/">ログイン</router-link>
      <span class="icon"><i class="fas fa-lg fa-sign-in-alt"></i></span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      dispname: state => state.auth.user.dispname,
      hasToken: state=> state.auth.hasToken,
      isSaigai: state=> state.auth.mode.mode_available == 2 ? true : false
    })
  },
  methods: {
    logout: function() {
      this.$store.dispatch('auth/logout');
      this.$router.push({ path: '/login' });
    }
  }
}
</script>